import { type SVGProps } from "react";

export function TextAaAreaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 16V10C7 9.46957 7.20486 8.96086 7.56951 8.58579C7.93417 8.21071 8.42875 8 8.94444 8C9.46014 8 9.95472 8.21071 10.3194 8.58579C10.684 8.96086 10.8889 9.46957 10.8889 10V16M7 12.5714H10.8889M17 12V16M2.81818 10L1 12L2.81818 14M21.1818 10L23 12L21.1818 14M13.1111 14C13.1111 14.5304 13.316 15.0391 13.6806 15.4142C14.0453 15.7893 14.5399 16 15.0556 16C15.5713 16 16.0658 15.7893 16.4305 15.4142C16.7951 15.0391 17 14.5304 17 14C17 13.4696 16.7951 12.9609 16.4305 12.5858C16.0658 12.2107 15.5713 12 15.0556 12C14.5399 12 14.0453 12.2107 13.6806 12.5858C13.316 12.9609 13.1111 13.4696 13.1111 14Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TextAaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 19V8.5C3 7.57174 3.36875 6.6815 4.02513 6.02513C4.6815 5.36875 5.57174 5 6.5 5C7.42826 5 8.3185 5.36875 8.97487 6.02513C9.63125 6.6815 10 7.57174 10 8.5V19M3 13H10M21 12V19M14 15.5C14 16.4283 14.3687 17.3185 15.0251 17.9749C15.6815 18.6313 16.5717 19 17.5 19C18.4283 19 19.3185 18.6313 19.9749 17.9749C20.6313 17.3185 21 16.4283 21 15.5C21 14.5717 20.6313 13.6815 19.9749 13.0251C19.3185 12.3687 18.4283 12 17.5 12C16.5717 12 15.6815 12.3687 15.0251 13.0251C14.3687 13.6815 14 14.5717 14 15.5Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TextSpellcheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 15V7.5C5 6.57174 5.36875 5.6815 6.02513 5.02513C6.6815 4.36875 7.57174 4 8.5 4C9.42826 4 10.3185 4.36875 10.9749 5.02513C11.6313 5.6815 12 6.57174 12 7.5V15M5 10H12M10 18L13 21L20 14"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TextTextIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5 13V20M18.5 13H21M18.5 13H16M10 4V20M10 4H16V7M10 4H4V7M10 20H12M10 20H8"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
